// import { FETCHCODERANGE } from "../constant/ActionType";

// export default function FetchedCode(
//     state = {
//         fetchedcode: [],
//         statusCode: null,
//     },
//     action
// ) {
//     switch (action.type) {
//         case FETCHCODERANGE:
//             return {
//                 ...state,
//                 fetchedcode: action.data,
//                 statusCode: action.status,
//             };

//         default:
//     }

//     return state;
// }

import { FETCHCODERANGE, RESET_FETCHED_CODE } from "../constant/ActionType";

export default function FetchedCode(
    state = {
        fetchedcode: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case FETCHCODERANGE:
            return {
                ...state,
                fetchedcode: action.data,
                statusCode: action.status,
            };

        case RESET_FETCHED_CODE:
            return {
                ...state,
                fetchedcode: [],
                statusCode: null,
            };

        default:
            return state;
    }
}
